var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      height: "100%"
    }
  }, [_c("div", {
    staticStyle: {
      height: "100%"
    }
  }, [_c("a-card", {
    staticStyle: {
      height: "100%"
    },
    attrs: {
      bordered: false
    }
  }, [_c("a-row", {
    attrs: {
      type: "flex",
      justify: "end"
    }
  }, [_c("a-col", [_c("a-button", {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      type: "primary",
      icon: "plus"
    },
    on: {
      click: _vm.add
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.new")))])], 1)], 1), _c("a-table", {
    attrs: {
      columns: _vm.columns,
      loading: _vm.isTableLoading,
      "data-source": _vm.serchKeywordList,
      pagination: false
    },
    scopedSlots: _vm._u([{
      key: "searchKeywords",
      fn: function fn(text, record) {
        return [_c("a-tooltip", [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(text) + " ")]), _c("span", {
          staticClass: "tooltipCenter"
        }, [_vm._v(" " + _vm._s(text) + " ")])], 2)];
      }
    }, {
      key: "action",
      fn: function fn(text, record) {
        return [_c("a", {
          on: {
            click: function click($event) {
              return _vm.edit(record.id);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("public.edit")))]), _c("a-divider", {
          attrs: {
            type: "vertical"
          }
        }), _c("a-popconfirm", {
          attrs: {
            title: _vm.$t("public.deletePromp"),
            "ok-text": _vm.$t("public.confirm"),
            "cancel-text": _vm.$t("public.cancel"),
            overlayStyle: {
              minWidth: "200px"
            }
          },
          on: {
            confirm: function confirm($event) {
              return _vm.deleteKeyword(record.id);
            }
          }
        }, [_c("a", {
          attrs: {
            href: "#"
          }
        }, [_vm._v(_vm._s(_vm.$t("publicuse.delete")))])])];
      }
    }])
  }, [_c("span", {
    attrs: {
      slot: "keywordTitle"
    },
    slot: "keywordTitle"
  }, [_vm._v(_vm._s(_vm.$t("serchKeyword.title")) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.defaultLangObj.langName) + " ")]), _c("a-icon", {
    attrs: {
      type: "exclamation-circle",
      rotate: 180
    }
  })], 2)], 1)])], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };